import apiAddress from "../_sig_api/_apiadress";
import createOptions from "../_helper/createOptions";
import {s_char_notes} from "../_signals/s_char";
import {ICharNote} from "../_interfaces/ICharNote";

export const NotesGet = (cid: string) => {
    fetch(apiAddress + "/char/notes/" + cid, createOptions('GET'))
        .then((res) => res.json())
        .then((data) => {
                if (data.hasOwnProperty('result')) {
                    console.log('BENotes get reponse', data.result);
                    s_char_notes.value = (data.result as ICharNote[])
                }
            }
        )
        .catch((reason => {
            console.log('BENotes get catch', reason);
        }))
}

export const NotesCreate = (note: ICharNote) => {
    fetch(apiAddress + "/char/notes/", createOptions('CREATE', note))
        .then((res) => res.json())
        .then((data) => console.log('BENotes create reponse', data))
        .catch((reason => console.log('BENotes create catch', reason)))
}

export const NotesUpdate = (note: ICharNote) => {
    fetch(apiAddress + "/char/notes/", createOptions('UPDATE', note))
        .then((res) => res.json())
        .then((data) => console.log('BENotes update repsonse', data))
        .catch((reason => console.log('BENotes update catch', reason)))
}

export const NotesDelete = (note: ICharNote) => {
    fetch(apiAddress + "/char/notes/", createOptions('DELETE', note))
        .then((res) => res.json())
        .then((data) => console.log('BENotes delete repsonse', data))
        .catch((reason => console.log('BENotes delete catch', reason)))
}